import apiWrapper from '../../services/apiWrapper';

export const generateLink = async (churchId) => {
  try {
    const response = await apiWrapper('post', '/admin/generate-link', { churchId });
    return response;
  } catch (error) {
    console.error('Error generating link:', error);
    throw error;
  }
};
